import {css} from 'lit';
export const styles = css`:host {
  --trigger-height: auto;
  --trigger-border-radius: 16px;
  --trigger-bg: var(--primary-600);
  --trigger-hover-bg: var(--primary-700);
  --trigger-active-bg: var(--primary-600);
  --trigger-hover-text: var(--yellow-400);
  --trigger-font-size: var(--font-size-sm);
  --trigger-padding: 2px 8px 4px; /* 2px top and 4px bottom - because we are artificially centering globe icon using margin top 2px */

  display: block;
}

ef-dot-menu::part(language) {
  --min-width: 0; /* width of the icon */
}

ef-dot-menu::part(dot-item-active) {
  background-color: var(--primary);
  color: var(--contrast-light);
  margin: -8px;
  padding: 8px;
}

.xs-btn {
  height: var(--trigger-height);
  padding: var(--trigger-padding);
  border-radius: var(--trigger-border-radius);
  background-color: var(--trigger-bg);
  font-size: var(--trigger-font-size);
  display: flex;
  align-items: center;
  font-weight: 400;
  border: 0;
}

.xs-btn[aria-expanded='true'] {
    background-color: var(--trigger-hover-bg);
  }

@media (hover: hover) {
    .xs-btn:hover {
      background-color: var(--trigger-hover-bg);
      color: var(--trigger-hover-text);
    }
  }

.xs-btn:active {
    background-color: var(--trigger-active-bg);
  }

.xs-btn ef-icon {
    background-color: var(--primary-200);
    border-radius: 50%;
    color: var(--dark-text);
    border: 2px solid var(--primary);
    margin-top: 2px;
    font-size: 24px;
  }
`;
export default styles;
